import {Container, Dropdown, Menu} from "semantic-ui-react";
import {DawidConfirm} from "./confirm.jsx";
import React, {Component} from 'react'

const menuStyle = {
    // border: 'none',
    // borderRadius: 0,
    // boxShadow: 'none',
    marginBottom: '1em',
    // marginTop: '1em',
    transition: 'box-shadow 0.5s ease, padding 0.5s ease',
    // backgroundColor: '#fff',
};

const fixedMenuStyle = {
    // backgroundColor: '#fff',
    border: '1px solid #ddd',
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
};

export default class DawidMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmOpen: false,
            selectedFlow: this.props.currentFlowId,
            activeItem: 'data_collection'
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(this.props.menuFixed === nextProps.menuFixed &&
            this.props.currentFlowId === nextProps.currentFlowId && this.props.flows === nextProps.flows && this.state === nextState);
    }

    selectFlow(flowId) {
        this.setState({selectedFlow: flowId, confirmOpen: true})
    }

    setActive(item) {
        this.setState({'activeItem': item});
        this.props.goSection(item);
    }

    render() {
        let {activeItem} = this.state;
        let label;
        if (this.props.currentFlowId !== undefined) {
            const currentFlow = this.props.flows[this.props.currentFlowId];
            label = currentFlow.name + " (v" + currentFlow.version + ")"
        } else {
            label = 'Form flows';
        }
        return (<Menu stackable
                      fixed={this.props.menuFixed ? 'top' : undefined}
                      style={this.props.menuFixed ? fixedMenuStyle : menuStyle}
        >
            <Container className={"no-print"} fluid>
                {/*<Menu.Item>*/}
                {/*<Image size='mini' src='/logo.png'/>*/}
                {/*</Menu.Item>*/}
                <Menu.Item style={{fontWeight: '400'}} onClick={() => {
                    this.setActive('data_collection');

                }} active={activeItem === 'data_collection'} header>Data collection</Menu.Item>
                <Menu.Item style={{fontWeight: '400'}} onClick={() => {
                    this.setActive('summary');
                }} active={activeItem === 'summary'} header>Summary</Menu.Item>
                {/*<Menu.Item disabled as='a'>Blog</Menu.Item>*/}

                <Menu.Menu position='right'>
                    <Dropdown text={label} pointing className='link item'>
                        <Dropdown.Menu>
                            {
                                Object.keys(this.props.flows).map((flowId, keyIndex) => {
                                    const flow = this.props.flows[flowId];
                                    return (
                                        <Dropdown.Item key={'dflow' + keyIndex}
                                                       active={flowId === this.props.currentFlowId}
                                                       onClick={() => this.selectFlow(flowId)}
                                        >
                                            {flow.name} (v{flow.version})
                                        </Dropdown.Item>
                                    )
                                        ;
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Container>
            <DawidConfirm open={this.state.confirmOpen}
                          onConfirm={() => {
                              this.props.changeFlow(this.state.selectedFlow);
                              this.setState({confirmOpen: false})
                          }}
                          onCancel={() => this.setState({confirmOpen: false})}
                          content={"Are you sure you want to switch to a different flow? " +
                          "All progress that has not been saved will be lost."}
                          cancelText={"I changed my mind, don't switch"}
                          confirmText={"Change flow"}
            />
        </Menu>)
    }

}